import React from "react";
import { Trans } from "react-i18next";

// `titulo` y `styles` traen por omisión lo que ya usaba el modal de calificar
// del profesor: solo la vista del alumno los cambia, para que su subtítulo
// combine con los demás de esa pantalla.
function ComentariosBox({
  comentarios,
  textareaValue,
  setTextareaValue,
  readOnly,
  titulo = "Añadir comentarios",
  styles = "font-bold text-black mb-4",
}) {
  return (
    <div className="w-full inline-block whitespace-pre-wrap">
      <div className={styles}>
        <Trans i18nKey="">{titulo}</Trans>
      </div>
      <div className="max-h-[25rem] overflow-auto mb-4">
        {comentarios
          .filter((el) => el.comentario)
          .sort((a, b) => {
            if (a.fecha > b.fecha) {
              return 1;
            } else {
              return -1;
            }
          })
          .map((el, i) => (
            <div
              key={i}
              className={`w-full ${
                el.rol === "profesor" ? "flex justify-end" : ""
              }`}
            >
              {/* El comentario del profesor va en el mismo azul que los
                  criterios seleccionados de la rúbrica; con fondo sólido el
                  texto necesita ir en blanco para leerse. */}
              <div
                className={`bg-[#eff1f5] w-fit rounded-lg p-2 mb-2 ${
                  el.rol === "profesor" ? "!bg-[#3a93e3] text-white" : ""
                }`}
              >
                {el.esEliminado ? "Mensaje eliminado" : el.comentario}
              </div>
            </div>
          ))}
      </div>
      {!readOnly && (
        <textarea
          className={`rounded-lg border border-[#dcdcdc] min-h-[7rem] w-full `}
          placeholder=""
          onChange={(e) => setTextareaValue(e.target.value)}
          value={textareaValue}
        ></textarea>
      )}
    </div>
  );
}

export default ComentariosBox;
